import React from 'react';
import style from './style.module.css';

const GreyDivider: React.FC = () => <div className={style.greyDivider} />;

export default GreyDivider;
